import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-general-error-view',
  templateUrl: './general-error-view.component.html',
  styleUrls: ['./general-error-view.component.scss'],
  standalone: false
})
export class GeneralErrorViewComponent {
  constructor(private router: Router) {}

  navigateToHomepage() {
    this.router.navigateByUrl('');
  }
}
